import Swal from "sweetalert2";

export function ErrorAlert(msg) {
  Swal.fire({
    position: "top-end",
    icon: "error",
    title: msg,
    toast: true,
    showConfirmButton: false,
    timer: 3500,
  });
}

export function SuccessAlert(msg) {
  Swal.fire({
    position: "top-end",
    icon: "success",
    title: msg,
    toast: true,
    showConfirmButton: false,
    timer: 3500,
  });
}
